import { useState } from "react";

import styles from "@styles/forms-flow/forms.module.scss";

import { BaseCurrencyInput, Button } from "@components";

export const DaysMonth = ({ data, onApply }) => {
  const [selectedDays, setSelectedDays] = useState(
    data.type == "DAYS_MONTH" ? data.value || [] : []
  );
  const [inputDay, setInputDay] = useState("");

  const selectDaysMonth = (day) => {
    if (+day < 1 || +day > 31 || Number.isNaN(day)) {
      return false;
    }
    setSelectedDays((oldArray) => [...new Set([...oldArray, day])]);
    setInputDay("");
  };

  return (
    <div className={styles.daysMonth}>
      <div className={styles.hairline} />

      <p className={styles.label}>Defina os dias do mês</p>

      <div className="d-flex align-center mt-30">
        <BaseCurrencyInput
          label="Dia do mês"
          className="w-100 mr-15"
          precision={0}
          prefix=""
          max={2}
          design="two"
          value={inputDay}
          onEnter={() => selectDaysMonth(inputDay)}
          onChange={(v) => setInputDay(v)}
        />
        <Button
          design="simple"
          className="mb-15"
          onClick={() => selectDaysMonth(inputDay)}
        >
          Aplicar
        </Button>
      </div>

      <div className={styles.days}>
        {selectedDays.map((day, _i) => (
          <div className={styles.day}>
            <span>{day}</span>
            <i
              className="far fa-times"
              onClick={() => {
                setSelectedDays(selectedDays.filter((value) => value !== day));
              }}
            />
          </div>
        ))}
      </div>

      <div className={styles.footer}>
        <Button
          onClick={() => onApply({ monthDays: selectedDays })}
          className="w-100"
          design="primary"
        >
          Aplicar
        </Button>
      </div>
    </div>
  );
};
